import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

import MainNavbar from './components/MainNavbar';
import BackToTop from './components/BackToTop';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import DesignLab from './pages/Design_Lab';
import StoryLab from './pages/Story_Lab';
import Contact from './pages/Contact';
import NewClient from './pages/NewClient';
import Packages from './pages/Packages';
import KickoffCall from './pages/KickoffCall';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsService from './pages/TermsService';

function AppLayout() {


  return (
    <div className="AppRoot">
      <MainNavbar />
      <BackToTop />
      <main className="AppMain">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/designlab" element={<DesignLab />} />
          <Route path="/storylab" element={<StoryLab />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/new-client" element={<NewClient />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/kickoff-call" element={<KickoffCall />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsService />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
